import { render, staticRenderFns } from "./CreateEdit.vue?vue&type=template&id=09483740&"
import script from "./CreateEdit.vue?vue&type=script&lang=js&"
export * from "./CreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports